module.exports = __webpack_public_path__ + "img/49.b6850ab9.png";